export default __webpack_public_path__ + "static/media/logo.9408fb49.png";